import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import Loader from './Loader'

import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';

import CustomDialog from './inputs/CustomDialog'
import TemplatePreview from './TemplatePreview'
import InstaTable from './InstaTable'

import {
  templates_index,
  businesses_select,
  preferences_index,
  skills_index,
  users_select,
  publish_template,
  unpublish_template,
  trash_template,
  delete_template,
  reset_template,
  clear_template,
  templates_xlsx,
  set_path
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.template
  return {
    template: state.template,
    templates: items,
    pagination: pagination,
    totals: totals,
    tags: state.tag.items,
    businesses: state.business.select_items,
    current_user: state.auth.current_user.data,
    skills: state.skill.items,
    users: state.user.select_items,
    setStatus: state.template.set_status
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getBusinesses: () => dispatch( businesses_select() ),
    getTemplates: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( templates_index(page, per_page, filters, sort, order) ),
    templatesXLSX: (filters, sort, order, variant) => dispatch ( templates_xlsx(filters, sort, order, variant) ),
    publishTemplate: (template_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(publish_template(template_id, index, page, per_page, filters, sort, order)),
    unpublishTemplate: (template_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(unpublish_template(template_id, index, page, per_page, filters, sort, order)),
    trashTemplate: (template_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(trash_template(template_id, index, page, per_page, filters, sort, order)),
    deleteTemplate: (template_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => dispatch(delete_template(template_id, index, page, per_page, filters, sort, order)),
    resetTemplate: () => dispatch( reset_template() ),
    clearTemplate: () => dispatch( clear_template() ),
    getPreferences: () => dispatch( preferences_index() ),
    getSkills: () => dispatch( skills_index() ),
    getUsers: () => dispatch( users_select() ),
    setPath: path => dispatch( set_path(path) )

  }
}

class ConnectedTemplatesIndex extends React.Component {
  state={
    current_template: null,
    current_view: 'all',
    merge_filters: {trash: false},
    filterState: {},
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    const { results } = item
    if (field === "created_at" || field === "updated_at") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if ( field === "status" ) {
      const { active, trash } = item
      const theStatus = trash ? 'trash' : active ? 'published' : 'draft'
      renderText = this.statusIcon(theStatus)
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === 'creator') {
      renderText = item.creator ? item.creator.display_name : ''
    } else if (field === 'skill') {
      renderText = item.skill ? item.skill.name : ''
    } else if (field === 'count') {
      renderText = results.tests || 0
    } else if (field === 'duration') {
      renderText = results.average_runtime || 0
    } else if (field === 'percent_timeout') {
      renderText = `${Math.round( ( (results.tests && results.tests > 0) ?  ((results.timeout || 0) / results.tests) : 0 ) * 100 )} %`
    } else if (field.match(/^[abc][12]/)) {
      const {levels} = results
      renderText = <span style={{whiteSpace: 'nowrap'}}>{`${Math.round( ( (results.tests && results.tests > 0) ?  ((levels[field] || 0) / results.tests) : 0 ) * 100 )} %`}</span>
    } else if (field === 'tags' || field === 'businesses') {
      renderText = (item[field] && item[field] !== null) ? item[field].map( (t, i) => (
        <div style={{whiteSpace: 'nowrap'}} key={`inline_tag_${i}`}>{t.label}</div>
      )) : ''
    } else if (field === "actions" ) {
      const {active, trash} = item
      renderText = this.props.templatebase === 'index' ? (
        <React.Fragment>
          {(!active && !trash) && this.editLink(item)}
          {(active) && this.unpublishLink(item, state)}
          {(!active && !trash) && this.publishLink(item, state)}
          {(!active && !trash) && this.trashLink(item, state)}
          {(trash) && this.recoverLink(item, state)}
          {(trash) && this.deleteLink(item, state)}
        </React.Fragment>
      ) : this.resultsLink(item)
    // } else if (field === 'name' && this.props.templatebase === 'results' && !item.active ) {
    //   renderText = <Link to={`/templates/${item.id}/edit`} className="test_results_link" title="Edit Template">{item.name}</Link>
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getTemplates, current_user, getSkills, getUsers, getPreferences, getBusinesses } = this.props
    getTemplates()
    if (current_user.role === "admin") {
      getBusinesses()
      getPreferences()
      getSkills()
    }
    getUsers()
  }

  componentWillUnmount() {
    this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.setStatus) {
      this.props.resetTemplate()
    }
    if (!this.state.mounted) {
      if (!this.props.template.fetching && this.props.template.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    // const init_merge = this.props.templatebase === "results" ? {count: 1} : {}
    const init_merge = {trash: false}
    if (value === 'all') {
      this.setState({merge_filters: init_merge})
    } else if (value === 'active') {
      this.setState({merge_filters: {...init_merge, active: true} })
    } else if (value === 'draft') {
      this.setState({merge_filters: {...init_merge, active: false}})
    } else if (value === 'trash') {
      this.setState({merge_filters: {...init_merge, trash: true}})
    } else {
      return
    }
    this.setState({current_view: value})
  }

  editLink = template => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = template
      return (
        <Link to={`/templates/${id}/edit`} className="action-btn" title="Edit" onClick={this.props.clearTemplate}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>create</Icon>
        </Link>
      )
    } else {
      return ''
    }
  }

  unpublishLink = (template, state) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = template
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Unpublish to draft" onClick={e=>{
          e.preventDefault()
          this.props.unpublishTemplate(id, true,  page, per_page, filters, sort, order)
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>insert_drive_file</Icon>
        </Link>
      )
    }
    return ''

  }

  publishLink = (template, state) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = template
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Publish" onClick={e=>{
            e.preventDefault()
            this.props.publishTemplate(id, true,  page, per_page, filters, sort, order)
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>check_circle</Icon>
        </Link>
      )
    }
    return ''
  }

  trashLink = (template, state) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = template
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Move to trash" onClick={e=>{
            e.preventDefault()
            this.props.trashTemplate(id, true,  page, per_page, filters, sort, order)
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete</Icon>
        </Link>
      )
    }
    return ''
  }

  deleteLink = (template, state) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = template
      return (
        <Link to="" className="action-btn" title="Permanently delete" onClick={e=>{
            e.preventDefault()
            this.setState({showDialog: true, current_id: id, filterState: state})
        }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete_forever</Icon>
        </Link>
      )
    }
    return ''
  }

  resultsLink = (template) => {
    const {current_user} = this.props
    if (current_user.role === "admin" || current_user.role === 'expert') {
      const {longid} = template
      return (
        <Link to={`/tests/template?template_id=${longid}`} className="action-btn" title="Test Results" target="_blank">
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>insert_chart</Icon>
        </Link>
      )
    }
    return ''
  }

  destroy = (id) => {
    const {filters, sort, order, page, per_page} = this.state.filterState
    this.props.deleteTemplate(id, true,  page, per_page, filters, sort, order)
    this.hideDialog()
    this.setState({filterState: {}})
  }

  hideDialog() {
    this.setState({showDialog: false, showPreview: false, current_template: {}})
  }

  recoverLink = (template, state) => {
    const {current_user} = this.props
    if (current_user.role === "admin") {
      const {id} = template
      const {filters, sort, order, page, per_page} = state
      return (
        <Link to="" className="action-btn" title="Restore" onClick={e=>{
            e.preventDefault()
            this.props.unpublishTemplate(id, true,  page, per_page, filters, sort, order)
          }}>
          <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>restore_page</Icon>
        </Link>
      )
    }
    return ''
  }

  statusIcon = status => {
    if (status === 'trash') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="In Trash">delete</Icon>
    } else if (status === 'published') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Published">check_circle</Icon>
    } else if (status === 'draft') {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title="Draft">insert_drive_file</Icon>
    }
  }

  showPreview = template => {
    this.setState({showPreview: true, current_template: template})
  }

  headerButton = (filters, sort, order) => {
    if (this.props.current_user.role !== "admin") {
      return ''
    }
    return (
      <Hidden smDown>
        <a href='' style={{float: 'right'}} onClick={e => {
          e.preventDefault()
          this.props.templatesXLSX(filters, sort, order, this.props.templatebase)
        }}>
          Download XLSX
        </a>
      </Hidden>
    )
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( ["expert", "admin"].indexOf(role) < 0 ) {
      return <Redirect to="/" />
    }

    const { templates, pagination, skills, users, totals, tags, businesses } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'name', disablePadding: true, label: 'Template Name', visible: "results"},
      { id: 'skill', disablePadding: true, label: 'Skill', requires: ['admin'] },
      { id: 'name', disablePadding: true, label: 'Template Name', visible: "index" },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'tags', disablePadding: true, label: 'Tags', disableSort: true, requires: ['admin'] },
      { id: 'businesses', disablePadding: true, label: 'B2B', disableSort: true },
      { id: 'creator', disablePadding: true, label: 'User', visible: "index" },
      { id: 'created_at', disablePadding: true, label: 'Creation Date', visible: "index" },
      { id: 'count', disablePadding: true, label: '#Ts Taken', visible: "results" },
      // { id: 'level_count', disablePadding: true, label: 'Tests/Level', visible: "results" },
      { id: 'percent_timeout', disablePadding: true, label: '% Time Out.', visible: "results" },
      ...['a1','a2','b1','b2','c1','c2'].map( l => {
        return {
          id: l, disablePadding: true, label: capitalize(l), visible: "results"
        }
      }),
      { id: 'duration', disablePadding: true, label: 'Time Avg.(m)', visible: "results" },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true, requires: ['admin'] },
    ].filter(
      c => c.requires === undefined || c.requires.indexOf(role) > -1
    ).filter(
      c => c.visible === undefined || c.visible === this.props.templatebase
    )

    const filterControls = [
      { name: "skill", filter_type: "select", valueField: "name", collection: skills, requires: ['admin'] },
      { name: "user", filter_type: "select", valueField: "display_name", collection: users, visible: "index" },
      { name: "tag", filter_type: "select", valueField: "name", collection: tags.filter( t => t.templates > 0) },
      { name: "business", label: "B2B", filter_type: "select", valueField: "name", collection: businesses.filter( t => t.templates > 0), requires: ['admin'] },
      { name: "created_at", filter_type: "date", visible: "index" },
      { name: "search", filter_type: "search", visible: "results" },
    ].filter(
      c => c.requires === undefined || c.requires.indexOf(role) > -1
    ).filter(
      c => c.visible === undefined || c.visible === this.props.templatebase
    )

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "active", label: "Published", value: totals.active },
      { name: "draft", label: "Draft", value: totals.draft },
      { name: "trash", label: "Trash", value: totals.trash },
    ]

    return (
      <div id="templates-wrapper" className={this.props.template.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            {this.props.header || 'Templates'}
          </Typography>
          {
            this.props.templatebase === "index" && role === 'admin' && (
              <CustomOutlinedButton
                component={Link}
                to="/templates/new"
                className="buttonnoto c-blue align-self-center"
                onClick={e=> this.props.setPath("newtemplate")}>
                Add Template
              </CustomOutlinedButton>
            )
          }
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={templates}
          pagination={pagination}
          role={role}
          merge_filters={this.state.merge_filters}
          rowGetter={this.props.getTemplates.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          previewColumn="name"
          clearItem={this.props.clearTemplate.bind(this)}
          previewItem={this.showPreview.bind(this)}
          classPrefix="template"
          addClassField="status"
          search={true}
          placeholders="ID, name"
          init_sort={ this.props.templatebase === 'results' ? 'name' : ''}
          init_order={ this.props.templatebase === 'results' ? 'asc' : ''}
          headerButton={this.headerButton.bind(this)}
        />

        <CustomDialog
          id="delete-dialog"
          fullScreen = {false}
          qid={this.state.current_id}
          isopen={this.state.showDialog}
          handleClose={this.hideDialog.bind(this)}
          handleAccept={this.destroy.bind(this)}
          title="Delete Template?"
        >
          This action cannot be undone
        </CustomDialog>
          <TemplatePreview
            id="preview-template-dialog"
            isopen={this.state.showPreview}
            template={this.state.current_template}
            handleClose={this.hideDialog.bind(this)}
          />
      </div>
    )
  }
}

const TemplatesIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedTemplatesIndex)

export default withStyles(styles)(TemplatesIndex)



// WEBPACK FOOTER //
// ./src/js/components/TemplatesBase.js